export default __webpack_public_path__ + "static/media/HomeSlider1.56e4d4ca.jpg";